<app-search-view-full-header
  [searchContainer]="searchContainer"
  [listFieldTemplateId]="searchContainer.listFieldTemplateId"
  [stayOnList]="true"
  [reloadOverview]="reloadOverview"
></app-search-view-full-header>

<ng-template #fieldSelectorPortal>
  <app-search-view-selector
    [selectorContainer]="operationContainer"
  ></app-search-view-selector>
  <div
    class="overlay"
    (click)="closeFieldSelector()"
    (keydown)="null"
  ></div>
</ng-template>
